module["exports"] = [
  "김",
  "이",
  "박",
  "최",
  "정",
  "강",
  "조",
  "윤",
  "장",
  "임",
  "오",
  "한",
  "신",
  "서",
  "권",
  "황",
  "안",
  "송",
  "류",
  "홍"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/name/last_name.js
// module id = 1446
// module chunks = 0